import React, { FC } from 'react';
import { ProjectId } from 'api/models';
import { useProjectDetail } from 'data/projects';
import { EmptyContent } from './_card-empty';
import { DataContent } from './_card-list';

export const Content: FC<{ projectId: number }> = ({ projectId }) => {
  const { data: project } = useProjectDetail(ProjectId(projectId));

  const hasStatusUpdates = (project?.pastProjectStatus ?? []).length > 0;

  return (
    <>
      {hasStatusUpdates ? (
        <DataContent
          data={project?.pastProjectStatus ?? []}
          projectId={projectId}
        />
      ) : (
        <EmptyContent projectId={projectId} />
      )}
    </>
  );
};
